import useWindowSize from "../helpers/useWindowSize.ts";
import { useThemeStore } from "../stores/ThemeStore";

const videoSrc = `${window.location.origin}/videos/desert-sunset.mp4`;
const fallBackSrc = `${window.location.origin}/videos/dune-loop-bgs.jpg`;

const VideoBox = () => {
  const { size } = useWindowSize();
  const { getTheme } = useThemeStore();

  const fontSize =
    size.width < 500 ? "20px" : size.width < 1280 ? "4vw" : "52px";

  return (
    <div className="video-welcome flex relative min-h-[200px] max-h-[200px] w-full duration-500 overflow-hidden justify-center items-center max-w-[1280px] text-center border border-black">
      {/* Hintergrundvideo */}
      <video
        className="absolute z-0 min-h-[500px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        loop
        autoPlay
        muted
        poster={fallBackSrc}
      >
        <source src={videoSrc} type="video/mp4" />
        <img src={fallBackSrc} alt="No video available" />
      </video>

      {/* Overlay */}
      <div
        className="absolute inset-0 pointer-events-none z-30"
        style={{
          backgroundColor:
            getTheme() === "light" ? "rgba(0,0,0,0.4)" : "rgba(0,0,0,0.6)",
        }}
      />

      {/* Text */}
      <div
        className="absolute z-30 font-bold font-raleway uppercase dune-text"
        style={{
          color:
            getTheme() === "light"
              ? "var(--ant-color-link)"
              : "rgb(102,168,194)",
          fontSize: fontSize,
        }}
      >
        Arrakis
      </div>
    </div>
  );
};

export default VideoBox;
